import { render } from "./Dashboard.vue?vue&type=template&id=6e8fde63"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Xampp\\htdocs\\public_html\\cliente.bettertech.com.br\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__